//BootstrapStarterUIContainer.jsx
import React, { useState, useRef } from 'react';
import BootstrapStarterHeader from './BootstrapStarterHeader';
import BootstrapStarterBody from './BootstrapStarterBody';
import SendUIContainer from './SendUIContainer';

import 'bootstrap/dist/css/bootstrap.min.css';
import './WriterUI.css';
//import './ColorMode.css'

const BootstrapStarterUIContainer = ({ fileName, setFileName }) => {
    // Lifted state management for writer mode and color mode
    const [writerMode, setWriterMode] = useState('Sheet');  // Default 'Sheet'
    const [colorMode, setColorMode] = useState('Light');  // Default 'Light'

    // Add state for tag library count
    const [tagLibraryCount, setTagLibraryCount] = useState(0);

    // Create ref to access SendUIContainer methods
    const sendUIRef = useRef();

    // Add handler for tag count changes
    const handleTagCountChange = (count) => {
        setTagLibraryCount(count);
    };

    // Function to initiate send UI scanner when SendUIContainer becomes visible
    const initiateSendUIScanner = () => {
        if (sendUIRef.current && sendUIRef.current.initiateProjectScanForSend) {
            sendUIRef.current.initiateProjectScanForSend();
        }
    };

    // Monitor the SendUIContainer visibility and trigger scanner when it becomes visible
    React.useEffect(() => {
        const sendContainer = document.getElementById('sendUIContainer');
        if (sendContainer) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        const isVisible = sendContainer.style.display !== 'none';
                        if (isVisible) {
                            // Small delay to ensure component is fully rendered
                            setTimeout(() => {
                                initiateSendUIScanner();
                            }, 100);
                        }
                    }
                });
            });

            observer.observe(sendContainer, {
                attributes: true,
                attributeFilter: ['style']
            });

            return () => observer.disconnect();
        }
    }, []);

    return (
        <div className={
            (writerMode === 'Doc' ? 'view-doc' :
                writerMode === 'Note Pad' ? 'view-notepad' :
                    writerMode === 'Sticky Note' ? 'view-stickynote' : '') +
            (colorMode === 'Neutral' ? ' view-neutral' :
                colorMode === 'Dark' ? ' view-dark' : '')
        }
        >

            <div id="bootstrapStarterUIContainer" className="bootstrapStarterUIContainer"
            >
                <BootstrapStarterHeader
                    fileName={fileName}
                    setFileName={setFileName}
                    writerMode={writerMode}
                    colorMode={colorMode}
                    tagLibraryCount={tagLibraryCount}
                />
                <BootstrapStarterBody
                    writerMode={writerMode}
                    setWriterMode={setWriterMode}
                    colorMode={colorMode}
                    setColorMode={setColorMode}
                    onTagCountChange={handleTagCountChange}
                />
            </div>

            <div id="sendUIContainer" style={{ display: 'none' }}>
                <SendUIContainer ref={sendUIRef} />
            </div>

        </div>
    );
};

export default BootstrapStarterUIContainer;